import "./SmallScreensLogVisitsComponent.css";
import { Avatar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { stringAvatar } from "../../../helpers/stringAvatar";
import GetSingleDeal from "../../../controllers/Enquiries/GetSingleDeal";

const SmallScreensLogVisitsComponent = ({
  ClientName,
  Status,
  Description,
  DateTime,
  DealID,
}) => {
  const [DealData, setDealData] = useState({});
  useEffect(() => {
    async function fetchData() {
      const SingleDealData = await GetSingleDeal(DealID);
      setDealData(SingleDealData);
      console.log("SingleDealData", SingleDealData);
    }
    fetchData();
  }, [DealID]);

  return (
    <div className="card small-screen-log-visits-card">
      <div className="card-body log-visits-card-body">
        <div className="card-header">
          <div className="card-header-col-first">
            <div className="col-first-image">
              {
                <Avatar
                  className="log-visit-avatar-image"
                  {...stringAvatar(ClientName)}
                />
              }
            </div>
            <div className="col-first-headings">
              <h2 className="col-first-name">{ClientName}</h2>
            </div>
          </div>
          <div className="card-header-col-second">
            <button
              type="button"
              className={`${
                Status === "interested"
                  ? "card-Interested-btn"
                  : Status === "not-interested"
                  ? "card-notInterested-btn"
                  : ""
              }`}
            >
              {`${
                Status === "interested"
                  ? "Interested"
                  : Status === "not-interested"
                  ? "Not Interested"
                  : ""
              }`}
            </button>
          </div>
        </div>

        <div className="card-content">
          <p className="log-visitor-paragraph mb-0">{Description}</p>
        </div>

        <div className="card-divider">
          <hr />
        </div>
        <div className="card-footer-content">
          <div className="footer-content-time">
            <svg
              className="mr-1"
              width="8"
              height="9"
              viewBox="0 0 8 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.2 4.13591V1.63636C7.2 1.41937 7.11571 1.21126 6.96569 1.05782C6.81566 0.904383 6.61217 0.818182 6.4 0.818182H4.728C4.56 0.343636 4.12 0 3.6 0C3.08 0 2.64 0.343636 2.472 0.818182H0.8C0.36 0.818182 0 1.18636 0 1.63636V7.36364C0 7.58063 0.0842854 7.78874 0.234315 7.94218C0.384344 8.09562 0.587827 8.18182 0.8 8.18182H3.244C3.748 8.68909 4.436 9 5.2 9C6.748 9 8 7.71955 8 6.13636C8 5.355 7.696 4.65136 7.2 4.13591ZM3.6 0.818182C3.82 0.818182 4 1.00227 4 1.22727C4 1.45227 3.82 1.63636 3.6 1.63636C3.38 1.63636 3.2 1.45227 3.2 1.22727C3.2 1.00227 3.38 0.818182 3.6 0.818182ZM0.8 7.36364V1.63636H1.6V2.45455H5.6V1.63636H6.4V3.55091C6.036 3.375 5.632 3.27273 5.2 3.27273H1.6V4.09091H3.24C3 4.32409 2.816 4.60227 2.672 4.90909H1.6V5.72727H2.432C2.412 5.86227 2.4 5.99727 2.4 6.13636C2.4 6.57818 2.5 6.99136 2.672 7.36364H0.8ZM5.2 8.18182C4.096 8.18182 3.2 7.26545 3.2 6.13636C3.2 5.00727 4.096 4.09091 5.2 4.09091C6.304 4.09091 7.2 5.00727 7.2 6.13636C7.2 7.26545 6.304 8.18182 5.2 8.18182ZM5.4 6.23864L6.544 6.93L6.244 7.42909L4.8 6.54545V4.5H5.4V6.23864Z"
                fill="#929292"
              />
            </svg>
            <span className="log-visitor-date-time">
              {/* 12/5/2022, 5:46:40 PM */}
              {DateTime?.toDate()?.toLocaleString("en-GB", {
                weekday: "long",
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
              })}
            </span>
          </div>
          <div className="footer-content-link">
            <svg
              className="mr-1"
              width="9"
              height="11"
              viewBox="0 0 9 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.47069 8.5451C1.76363 8.18217 1.48389 7.31241 1.84682 6.60535L2.69578 4.9514L1.91015 4.54814L1.0612 6.20209C0.475416 7.34332 0.926212 8.74495 2.06744 9.33073C3.20866 9.91651 4.61029 9.46571 5.19607 8.32449L6.04503 6.67054L5.2594 6.26728L4.41045 7.92123C4.04752 8.6283 3.17776 8.90803 2.47069 8.5451ZM3.75436 7.06204L5.45228 3.75414L4.6253 3.32966L2.92739 6.63756L3.75436 7.06204ZM3.18359 2.06722L2.33463 3.72117L3.12026 4.12442L3.96922 2.47047C4.33215 1.76341 5.20191 1.48367 5.90897 1.8466C6.61603 2.20953 6.89577 3.07929 6.53284 3.78635L5.68388 5.44031L6.46951 5.84356L7.31847 4.18961C7.90425 3.04838 7.45345 1.64675 6.31222 1.06097C5.171 0.475193 3.76937 0.92599 3.18359 2.06722Z"
                fill="#929292"
              />
            </svg>
            <Link
              to={`/user/deals/update/${DealID}`}
              className="log-visitor-link-text"
            >
              {DealData?.property?.propertyTitle}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmallScreensLogVisitsComponent;
